import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "m-accordion-group__wrapper",
  ref: "accordionGroup"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TpxAccordion = _resolveComponent("TpxAccordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accordions, (a) => {
      return (_openBlock(), _createBlock(_component_TpxAccordion, {
        class: "m-accordion-group__accordion",
        heading: a.heading,
        text: a.text,
        listItems: a.listItems,
        backgroundColour: _ctx.backgroundColour,
        link: a.link,
        key: a.heading,
        onClick: ($event: any) => (_ctx.closeAllNonClickedAccordions(a)),
        ref_for: true,
        ref: "accordionItems"
      }, null, 8, ["heading", "text", "listItems", "backgroundColour", "link", "onClick"]))
    }), 128))
  ], 512))
}